import React, { FunctionComponent } from 'react';
import { Stepper, StepperStep } from '../../shared/Stepper';
import { Step1 } from './steps';

interface StepsArray {
    component: FunctionComponent<{ id: number }>;
}

const steps: StepsArray[] = [
    {
        component: Step1,
    },
];

export const MLIStepper = () => {
    return (
        <Stepper defaultUrl="/" defaultPreviousText="Terug" previousButtonTexts={[]}>
            {steps &&
                steps.map((step, key) => (
                    <StepperStep id={key} key={key}>
                        <step.component id={key} />
                    </StepperStep>
                ))}
        </Stepper>
    );
};
